/**
 * LP 共通のスタイル定数 (Studio 版の値をそのまま採用)
 */

/** CTA・見出し装飾などのブランドグラデーション (45deg) */
export const GRADIENT_PRIMARY =
  'bg-[linear-gradient(45deg,#C20098_0%,#FF0082_42%,#FF8225_100%)]'

/** ページ背景 (ページ全体 / ヒーロー下) */
export const GRADIENT_PAGE =
  'bg-[linear-gradient(135deg,#E4FFE4_0%,#FFF4DE_100%)]'

/** セクション背景 (各セクションは 90% で止めたグラデーション) */
export const GRADIENT_SECTION =
  'bg-[linear-gradient(135deg,#E4FFE4_0%,#FFF4DE_90%)]'

/** Studio の appear / hover アニメーションのイージング */
export const EASE_OUT_EXPO = 'ease-[cubic-bezier(0.19,1,0.22,1)]'

/** ボタン類の hover (浮き上がり + 影) */
export const HOVER_LIFT = `transition-[transform,box-shadow,background-color] duration-[800ms] ${EASE_OUT_EXPO} hover:translate-y-[-10px] hover:shadow-[2px_10px_5px_rgba(0,0,0,0.2)]`
